import React, { useEffect, useRef, useState } from 'react'
import styles from './NewDeals.module.scss'
import NewDealProductItem from '../new-deal-item/NewDealProductItem';
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Keyboard, Autoplay } from 'swiper/modules';
import 'swiper/css/scrollbar';
import { useLazyNewDealsQuery } from '../../../../service/solar-product-service';
import { toast } from 'react-toastify';

type Props = {}

const NewDeals: React.FC<Props> = (props: Props) => {
    const swiperRef = useRef<SwiperRef>(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const [newDeals, { data }] = useLazyNewDealsQuery();

    const handleNext = () => {
        swiperRef?.current?.swiper?.slideNext();
    };

    const handlePrev = () => {
        swiperRef?.current?.swiper?.slidePrev();
    }

    const handleSlideChange = () => {
        setIsBeginning(swiperRef?.current?.swiper?.isBeginning ?? isBeginning);
        setIsEnd(swiperRef?.current?.swiper?.isEnd ?? isEnd);
    };

    useEffect(() => {
        newDeals(undefined, true)
        .unwrap()
        .catch(
            (err) => {
                toast.error(err.data?.title || "Something went wrong");
            }
        );
    }, [newDeals]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.titleContainer}>
                    <div className={styles.title}>
                        New Deals
                    </div>
                    <div className={styles.description}>
                        Promotions, deals, and special offers for you
                    </div>
                </div>
                <div className={styles.arrows}>
                    <svg className={styles.clickable} onClick={handlePrev} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="36" height="36" rx="18" fill={isBeginning ? 'gray' : 'black'} fillOpacity="0.9"/>
                        <path d="M21.7928 26L14.4999 18.7071C14.1094 18.3166 14.1094 17.6834 14.4999 17.2929L21.7928 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <svg className={styles.clickable} onClick={handleNext} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="36" height="36" rx="18" fill={isEnd ? 'gray' : 'black'} fillOpacity="0.9"/>
                        <path d="M14.207 10L21.4999 17.2929C21.8904 17.6834 21.8904 18.3166 21.4999 18.7071L14.207 26" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            <Swiper
                ref={swiperRef}
                slidesPerView={4}
                spaceBetween={20}
                // loop
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                }}
                keyboard={{
                    enabled: true,
                }}
                breakpoints={{
                  0: {
                      slidesPerView: 1,
                  },
                  720: {
                      slidesPerView: 2,
                  },
                  1320: {
                      slidesPerView: 3,
                  },
                  1720: {
                      slidesPerView: 4,
                  }
                }}
                modules={[Keyboard, Autoplay]}
                className={styles.swiper}
                onSlideChange={handleSlideChange}
            >
                {
                    data?.map((product, _) => (
                        <SwiperSlide key={product.id} className={styles.swiperSlide}>
                            <NewDealProductItem product={product} />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}

export default NewDeals